<header class="container">
  <h1></h1>
  <nav id="menuNavigation" class="navbar navbar-expand-lg navbar-light site-header-navigation">
    <span class="navbar-brand">
      <a routerLink="/" routerLinkActive="active"><img id="navBarImage" src="assets/images/mbtilogo.png" alt="MBTI Logo" class="mbti-logo" /></a>
    </span>
    <button
      class="navbar-toggler collapsed"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav justify-content-center main-nav" id="top-nav">
        <li class="nav-item" id="results-nav" tabindex="0" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
          <a id="header-results-link" href="/results" class="nav-link" routerLink="/results" routerLinkActive="nav-link-active" data-closemenu=""
            >Your Results</a
          >
        </li>
        <li class="nav-item" id="team-nav" tabindex="0" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
          <a id="header-team-link" href="/team" class="nav-link" routerLink="/team" routerLinkActive="nav-link-active" data-closemenu="">Your Team</a>
        </li>
        <li class="nav-item" id="learn-nav" tabindex="0" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
          <a id="header-courses-link" href="/learn" class="nav-link" routerLink="/learn" routerLinkActive="nav-link-active" data-closemenu=""
            >Courses</a
          >
        </li>
        <li class="nav-item" id="manage-nav" tabindex="0" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show" *ngIf="isTeamLeader">
          <a id="header-manage-link" href="/manage" class="nav-link" routerLink="/manage" routerLinkActive="nav-link-active" data-closemenu=""
            >Manage Team</a
          >
        </li>
      </ul>

      <ul class="navbar-nav mb-hamburger-menu d-block d-lg-none">
        <li class="dropdown-divider divider-line"></li>
        <li class="nav-item" id="account-nav" tabindex="0" *ngIf="!isElevateTeam">
          <a id="mb-hamburger-menu-accountmanagement-link" (click)="openAccount()" class="nav-link" href="javascript:void(0)">Account</a>
        </li>
        <li class="nav-item" id="account-nav" tabindex="0" *ngIf="isElevateTeam">
          <a id="mb-hamburger-menu-accountmanagement-link" (click)="backToElevate()" href="javascript:void(0)" class="nav-link"
            >Back to Elevate Dashboard</a
          >
        </li>
        <li class="dropdown-divider transparent"></li>
        <li class="nav-item" id="guide-nav" tabindex="0">
          <a id="mb-hamburger-menu-guide-link" class="nav-link pointer" href="/guide" routerLink="/guide">Tutorial</a>
        </li>
        <li class="nav-item" id="signout-nav" tabindex="0">
          <a id="mb-hamburger-menu-signout-link" class="nav-link pointer" (click)="signOut()">Log-Out</a>
        </li>
        <li class="dropdown-divider divider-line"></li>
        <li class="nav-item">
          <a class="nav-link" href="https://links.themyersbriggs.com/gm2wecta" target="_blank">Support</a>
          <a class="nav-link" href="https://links.themyersbriggs.com/9saek9kk" target="_blank">Privacy Policy</a>
          <a class="nav-link" href="https://www.mbtionline.com/Legal#terms" target="_blank">Terms</a>
        </li>
        <li class="nav-item"><small class="navbar-text">&copy; The Myers-Briggs Company</small></li>
      </ul>

      <ul class="navbar-nav ms-auto mb-menu" id="account-nav">
        <li class="nav-item tutorial-nav d-none d-sm-block" id="tutorial-nav-desktop">
          <button
            class="button-to-hyperlink"
            tabindex="0"
            role="dialog"
            aria-label="Tutorial"
            data-bs-toggle="modal"
            data-bs-target="#tutorialModal"
            href="/guide"
            routerLink="/guide"
          >
            Tutorial
          </button>
        </li>
        <li class="tutorial-divider d-none d-sm-block" id="share-nav-divider"></li>
        <li class="nav-item dropdown account-dropdown">
          <div class="account-dropdown-button" id="accountMenu" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="initials">{{ initials }}</div>
            <img src="assets/images/icons/arrow-down.svg" class="arrow-down" />
          </div>
          <div class="dropdown-menu header-account-dropdown-menu-wrapper dropdown-menu-end" tabindex="-1">
            <a
              id="menu-accountmanagement-link"
              (click)="openAccount()"
              class="dropdown-item header-account-dropdown-menu"
              href="javascript:void(0)"
              data-closemenu
              *ngIf="!isElevateTeam"
            >
              Account
            </a>
            <a
              *ngIf="isTeamLeader && !isElevateTeam"
              id="menu-paymenthistory-link"
              (click)="billingHistory()"
              class="dropdown-item header-account-dropdown-menu"
              href="javascript:void(0)"
              data-closemenu
            >
              Payment Receipt
            </a>
            <a
              *ngIf="isElevateTeam"
              id="menu-elevate-dashboard-link"
              (click)="backToElevate()"
              class="dropdown-item header-account-dropdown-menu"
              href="javascript:void(0)"
              data-closemenu
            >
              Back to Elevate Dashboard
            </a>
            <div class="dropdown-divider transparent"></div>
            <a id="menu-signout-link" class="dropdown-item header-account-dropdown-menu pointer" (click)="signOut()"> Log-Out </a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</header>
